import { useEffect, useState } from 'react';
import apiClient from '@utils/api-client';
import { apiInternalSignatureTypesPath } from '../../routes';
const useGetSignatureTypes = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        setError(undefined);
        apiClient
            .get(apiInternalSignatureTypesPath(), {
            signal: controller.signal
        })
            .then((response) => {
            // TODO: When expand signatures beyond Inspection, put conditional
            const types = response.data.data.filter((x) => x.blurbKey !== 'client_service_signature_blurb');
            setData(types.sort((x) => x.order));
        })
            .catch((err) => {
            if (!controller.signal.aborted) {
                setData([]);
                setError(err);
            }
        })
            .finally(() => {
            if (!controller.signal.aborted) {
                setLoading(false);
            }
        });
        return () => {
            controller.abort();
        };
    }, []);
    return { signatureTypes: data, loading, error };
};
export default useGetSignatureTypes;
